/* eslint-disable import/first */
import React from 'react';
import Hreflang from '../../components/Hreflang';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { Grid, Button, Typography, Paper } from '@material-ui/core';
import Header from '../../components/Header';
import LanguageButton from '../../components/LanguageButton';
import { MdCall } from '@react-icons/all-files/md/MdCall';
import { AiOutlineMail } from '@react-icons/all-files/ai/AiOutlineMail';
import { FormattedMessage } from 'react-intl';

import SeoTitle from '../../components/SeoTitle';
import contactUs from './contactUs.svg';
import css from './index.module.scss';

const ContactUs = () => {
  const config = useSelector((state) => state.config);
  const contrySpecificValidation = config?.data?.data?.contrySpecificValidation;
  const profile = useSelector((state) => state.profile);
  const countryName = profile?.country;

  const isExist = contrySpecificValidation?.findIndex(({ country }) => country === countryName);
  // eslint:fix 'tel' + ' ' replaced with 'tel '
  const path = 'tel: ' + contrySpecificValidation?.[isExist].customerCare;
  return (
    <Grid>
      <SeoTitle id="contactus" />
      <Hreflang page="contactus" />
      <Header
        title={<FormattedMessage id="navigation_contactUs" defaultMessage="Contact Us" />}
        actionButtons={[<LanguageButton />]}
        tellNumber={contrySpecificValidation?.[isExist].customerCare}
        // actionButtons={[<LanguageButton />]}
      />

      <Grid className={css.contactUsContainer}>
        <Grid className={css.headerText}>
          <FormattedMessage id="letsConnect" defaultMessage="Let’s Connect" />
        </Grid>
        <Grid>
          <img src={contactUs} alt="contact us" />
        </Grid>
        <div className={css.wrapper}>
          <Grid className={css.descText}>
            <Typography>
              <FormattedMessage
                id="contactUs_giveUsCall"
                defaultMessage="Sometimes you just need to speak to a real person. Give us a call."
              />
            </Typography>
          </Grid>
          <Grid className={css.reachUsHeading}>
            <Typography>
              <FormattedMessage id="contactUs_reachUsOn" defaultMessage="You can reach us on" />
            </Typography>
          </Grid>
          <Grid className={css.callUsContainer}>
            <Paper>
              <Grid className={css.callContainer}>
                <Grid className={css.callIcon}>
                  <MdCall />
                </Grid>

                <Grid className={css.customerCare}>
                  <a href={path}>
                    <Typography>{contrySpecificValidation?.[isExist].customerCare}</Typography>
                  </a>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid className={css.emailusContainer}>
            <Paper>
              <Grid className={css.emailContainer}>
                <Grid className={css.callIcon}>
                  <AiOutlineMail />
                </Grid>
                <Grid className={css.customerCare}>
                  <a
                    href={`mailto:${contrySpecificValidation?.[isExist].supportEmail}?subject=SendMail&body=Description`}
                  >
                    <Typography>{contrySpecificValidation?.[isExist].supportEmail}</Typography>
                  </a>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </div>
      </Grid>
    </Grid>
  );
};

export default ContactUs;
